(function () {
  function normalize(str) {
    return (str || "").toString().trim().toLowerCase();
  }

  function getListForInput(input) {
    // Desktop
    const fieldset = input.closest("fieldset");
    if (fieldset) {
      const list = fieldset.querySelector("ul[role='list'].no-js-hidden");
      if (list) return list;
    }

    // Mobile
    const submenu = input.closest(".mobile-facets__submenu");
    if (submenu) {
      const list = submenu.querySelector("ul.mobile-facets__list[role='list']");
      if (list) return list;
    }

    return null;
  }

  function ensureEmptyState(input) {
    const wrap = input.closest(".facets__search, .mobile-facets__search") || input.parentElement;
    let msg = wrap.querySelector(".facet-search-empty");
    if (!msg) {
      msg = document.createElement("div");
      msg.className = "facet-search-empty";
      msg.textContent = "No matches";
      wrap.appendChild(msg);
    }
    return msg;
  }

  function revealShowMoreItems(list, reveal) {
    const items = Array.from(list.querySelectorAll(":scope > li.show-more-item"));
    items.forEach((li) => {
      if (reveal) {
        if (!li.dataset.wasHiddenByShowMore) {
          li.dataset.wasHiddenByShowMore = li.classList.contains("hidden") ? "1" : "0";
        }
        li.classList.remove("hidden");
      } else {
        if (li.dataset.wasHiddenByShowMore === "1") li.classList.add("hidden");
        li.removeAttribute("data-was-hidden-by-show-more");
      }
    });
  }

  function setVisible(li, show) {
    const filteredOut = !show;

    // Preferred: class-based hide (so CSS can win with !important)
    li.classList.toggle("facet-item--filtered-out", filteredOut);

    // Accessibility + fallback
    li.hidden = filteredOut;
    li.setAttribute("aria-hidden", filteredOut ? "true" : "false");
  }

  function filterList(list, term, emptyEl) {
    const q = normalize(term);
    const items = Array.from(list.querySelectorAll(":scope > li"));

    revealShowMoreItems(list, Boolean(q));

    let visibleCount = 0;

    items.forEach((li) => {
      const label = li.querySelector("label");
      const text = normalize(label ? label.textContent : li.textContent);

      if (!q) {
        setVisible(li, true);
        visibleCount++;
        return;
      }

      const show = text.includes(q);
      setVisible(li, show);
      if (show) visibleCount++;
    });

    emptyEl.style.display = q && visibleCount === 0 ? "block" : "none";
    return visibleCount;
  }

  function triggerDawnFacetSubmit(fromEl) {
    // Dawn listens on the facet form for "input" events to build & fetch the new URL.
    const form =
      fromEl.closest("form") ||
      fromEl.closest("facet-filters-form")?.querySelector("form") ||
      fromEl.form;

    if (!form) return;

    // Fire an input event on the form itself (bubbles in case listeners are higher)
    form.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function getFirstVisibleLi(list) {
    // “Visible” here means not filtered out (class-based)
    return Array.from(list.querySelectorAll(":scope > li")).find(
      (li) => !li.classList.contains("facet-item--filtered-out") && !li.hidden
    );
  }

  function bindFacetSearchInputs(root = document) {
    const inputs = root.querySelectorAll("input[data-facet-search-input]");

    inputs.forEach((input) => {
      if (input.dataset.facetSearchBound === "1") return;
      input.dataset.facetSearchBound = "1";

      const list = getListForInput(input);
      if (!list) return;

      const emptyEl = ensureEmptyState(input);

      const runFilter = () => filterList(list, input.value, emptyEl);
      input.addEventListener("input", runFilter);
      input.addEventListener("search", runFilter);

      // Run once immediately in case input already has value
      runFilter();

      input.addEventListener("keydown", (e) => {
        if (e.key !== "Enter") return;

        e.preventDefault();

        // Ensure list is filtered with latest value before selecting
        runFilter();

        const firstVisibleLi = getFirstVisibleLi(list);
        if (!firstVisibleLi) return;

        const checkbox = firstVisibleLi.querySelector('input[type="checkbox"]');
        if (!checkbox) return;

        if (!checkbox.checked) {
          checkbox.checked = true;

          // Dawn can listen to either input or change depending on version/customization
          checkbox.dispatchEvent(new Event("input", { bubbles: true }));
          checkbox.dispatchEvent(new Event("change", { bubbles: true }));
        }

        // This is the critical part: ensure the facets form submits via Dawn’s listener
        triggerDawnFacetSubmit(checkbox);
      });
    });
  }

  function run() {
    bindFacetSearchInputs(document);
  }

  document.addEventListener("DOMContentLoaded", run);
  document.addEventListener("shopify:section:load", run);

  const obs = new MutationObserver(() => run());
  obs.observe(document.documentElement, { subtree: true, childList: true });
})();
